import React from 'react';
import Typography from '../../../../components/atoms/Typography';
import Box from '../../../../components/molecules/Box';
import useStyles from './style';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { breakpoints } from '../../../../../styles/themes/vad/constants';

const ScheduleSession = ({ sessionDate = '', sessionTime = '', sessionVenueTitle = '' }) => {
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);
  const classes = useStyles();

  return (
    <Box className={`${classes.contentBox} contentBox`}>
      <Box className={classes.innerContent}>
        <Typography animateSettings={{ willAnimate: false }} className='dateHeading' variant="body3Bold" component="p">{sessionDate}</Typography>
      </Box>
      <Box className={classes.innerContent}>
        <Typography animateSettings={{ willAnimate: false }} className='contentText' variant="body3" component="p">{sessionTime}</Typography>
      </Box>
      {!isMobile && (
        <Box className={classes.innerContent}>
          <Typography animateSettings={{ willAnimate: false }} className={`contentText sessionVenueTitle`} variant="body3" component="p">{sessionVenueTitle}</Typography>
        </Box>
      )}
      {isMobile && (
        <Box className={classes.mobileOnly}>
          <Box className={classes.innerContent}>
            <Typography animateSettings={{ willAnimate: false }} className='contentText' variant="body3" component="p">{sessionVenueTitle}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default ScheduleSession
